import { IDropdownOption } from '@fluentui/react';

const normalizeDropdownValue = (value: unknown): string => String(value ?? '').trim();

export const isPlaceholderOption = (
  option: IDropdownOption | undefined,
  placeholder: string | undefined
): boolean => {
  const normalizedPlaceholder = normalizeDropdownValue(placeholder);
  if (!option) {
    return false;
  }

  const normalizedKey = normalizeDropdownValue(option.key);
  const normalizedText = normalizeDropdownValue(option.text);

  return (
    normalizedKey === '' ||
    (normalizedPlaceholder !== '' &&
      (normalizedKey === normalizedPlaceholder || normalizedText === normalizedPlaceholder))
  );
};

export const normalizeDropdownOption = (
  option: IDropdownOption | undefined,
  placeholder: string | undefined
): IDropdownOption | undefined => {
  return option && isPlaceholderOption(option, placeholder) ? { ...option, key: '' } : option;
};

export const getSelectableDropdownOptions = (
  options: IDropdownOption[] | undefined,
  placeholder: string | undefined
): IDropdownOption[] => {
  return (options ?? []).filter((option) => !isPlaceholderOption(option, placeholder));
};

export const getValidDropdownKey = (
  selectedValue: unknown,
  options: IDropdownOption[] | undefined,
  placeholder?: string
): string => {
  const normalizedValue = normalizeDropdownValue(selectedValue);
  if (normalizedValue === '') {
    return '';
  }

  const selectedOption = (options ?? []).find(
    (option) =>
      normalizeDropdownValue(option.key) !== '' &&
      normalizeDropdownValue(option.key) === normalizedValue
  );

  return selectedOption && !isPlaceholderOption(selectedOption, placeholder)
    ? String(selectedOption.key)
    : '';
};

// Generated by GitHub Copilot | Updated on: 2026-08-11 | 27 lines created | Added shared placeholder option filtering
// Generated by GitHub Copilot | Updated on: 2026-08-11 | 6 lines modified | Detected mismatched placeholder labels
// Generated by GitHub Copilot | Updated on: 2026-08-11 | 4 lines modified | Filtered empty sentinels without props
// Generated by GitHub Copilot | Updated on: 2026-08-13 | 16 lines modified | Validate submitted dropdown keys
// Generated by GitHub Copilot | Updated on: 2026-08-14 | 17 lines modified | Preserve selectable placeholders as empty keys
